import React from 'react';

export default function About({ t }) {
  return (
    <section id="about" className="max-w-content mx-auto px-4 md:px-8 py-16 md:py-24">
      <div className="grid grid-cols-1 md:grid-cols-[1.2fr_1fr] gap-10 md:gap-16 items-start">

        {/* Left — bio */}
        <div>
          <div className="font-mono text-[13px] tracking-eyebrow uppercase text-ink-3 mb-3.5">
            04 / {t.nav.about}
          </div>
          <h2
            className="font-display font-medium text-ink m-0 mb-6"
            style={{ fontSize: 'clamp(32px, 4vw, 48px)', lineHeight: 1.05, letterSpacing: '-0.02em' }}
          >
            {t.about.title}
          </h2>
          {t.about.paragraphs.map((p, i) => (
            <p key={i} className="text-ink leading-relaxed m-0 mb-[18px]" style={{ fontSize: 17 }}>
              {p}
            </p>
          ))}
        </div>

        {/* Right — timeline */}
        <div>
          <div className="font-mono text-[13px] tracking-eyebrow uppercase text-ink-3 mb-3.5">
            Experience
          </div>
          <ul className="list-none p-0 m-0">
            {t.about.timeline.map((row, i) => (
              <li key={i} className="border-t border-rule py-3.5">
                {/* Mobile: stacked. Desktop: side-by-side. */}
                <div className="grid grid-cols-1 md:grid-cols-[170px_1fr] gap-0.5 md:gap-4">
                  <div className="font-mono text-[12px] text-ink-2 tracking-[0.04em]">
                    {row.when}
                  </div>
                  <div>
                    <div className="font-semibold text-[15px] text-ink mb-0.5">{row.what}</div>
                    <div className="text-[14px] text-ink-2">{row.where}</div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </section>
  );
}
